angular.module('bbl.module.plans-billings', [
  'bbl.services',
  'bbl.module.plans-billings.routing',
  'bbl.module.plans-billings.controller',
]);

require('./plans-billings.style.less');
require('./plans-billings.controller');
require('./plans-billings.routing');
require('./plans-widget/index');
require('./plan-box/index');



/*****************
 ** WEBPACK FOOTER
 ** ./app/modules/plans-billings/plans-billings.module.js
 ** module id = 364
 ** module chunks = 0
 **/